module.exports = __webpack_public_path__ + "static/aisingapore-a96962bed90e3d6dac9c0c4e442665c2.jpg";